@layer module {
.account-hero__head {
            display: flex;
            align-items: center;
    }

.account-hero__icon {
            flex-shrink: 0;
    }

.account-hero__tools {
            display: flex;
            align-items: center;
    }

.account-hero__title {
            flex-grow: 1;
            min-width: 0;
    }

.account-hero__name {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
    }

.account-hero__label {
            display: flex;
            align-items: center;
    }

.account-hero__swatch {
            display: inline-block;
    }

.account-hero__balance {
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
    }

.account-hero__actions {
            display: grid;
    }

.account-details {
            display: flex;
            flex-direction: column;
    }

      @media (max-width: 640px) {
                .account-hero__head {
                        flex-wrap: wrap;
                    }

                .account-hero__tools {
                        flex-basis: 100%;
                    }
          }
} // layer module










@layer app {
.account-hero__head {
            gap: $size-14;
    }

.account-hero__tools {
            gap: $size-14;
    }

.account-hero__label {
            gap: $size-8;
    }

.account-hero__swatch {
            width: $size-10;
            height: $size-10;
            border-radius: $size-3;
    }

.account-hero__currency {
            margin-left: $size-8;
    }

.account-hero__actions {
            grid-template-columns: repeat(auto-fit, minmax($size-120, 1fr));
            gap: $size-10;
    }

.account-details {
            gap: $size-12;
    }

.account-details__title {
            margin: 0;
    }

.account-hero__name {
            font-size: var(--font-size-xl);
            font-weight: 600;
    }

.account-hero__sub,
.account-hero__label {
            color: var(--hero-text-soft);
            font-size: var(--font-size-sm);
    }

.account-hero__icon {
            box-shadow: var(--shadow-account-workspace-marker);
    }

.account-hero__swatch {
            background: var(--color-action);
    }

.account-hero__balance {
            font-size: var(--font-size-4xl);
            font-weight: 500;
            font-variant-numeric: tabular-nums;
            letter-spacing: -1px;
            line-height: 1.15;
    }

.account-hero__currency {
            font-size: var(--font-size-lg);
            letter-spacing: 0;
    }

.account-details__title {
            color: var(--text-primary);
            font-size: var(--font-size-base);
            font-weight: 500;
    }
} // layer app
